export default String.raw`
.categories-map{
    &__categories{
        gap: 0;
    }
    .category{
        width: 50%;
        padding: 15px;
        &__name{
            margin-top: 15px;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
        }
    }
}
`